import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LangProvider } from "./context/LangContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <LangProvider>
        <App />
        </LangProvider>
    
  </React.StrictMode>
);

reportWebVitals();
